export const UPDATE_SECURITY_MAIN = 'update_security_main';
export const UPDATE_SSO_CONFIG = 'update_sso_config';
export const REMOVE_SECURITY_ROLE = 'remove_security_role';
export const UPDATE_SECURITY_ROLE = 'update_security_role';
export const ADD_SECURITY_ROLE = 'add_security_role';
export const ENABLE_SF_SUPPORT = 'enable_sf_support';
export const SHARE_DIAG = 'share_diagnostics';
export const SHARE_DIAG_ANON = 'share_diagnostics_anon';
export const UPDATE_PROXY_DATA = 'update_proxy_data';
